module.exports = __webpack_public_path__ + "img/chukwa.7696364c.jpg";